import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { IPStatusDto } from '@cradua/data';
import Swal from 'sweetalert2';


@Component({
  selector: 'cradua-ipstatus',
  templateUrl: './ipstatus.component.html',
  styleUrls: ['./ipstatus.component.scss']
})
export class IPStatusComponent implements OnChanges {


  ipstatusForm: FormGroup;
  ipstatusFormArray: FormGroup;
  control = new FormControl();
  @Input() ipstatuss: IPStatusDto[];
  @Input() routeAnimationsElements: any;
  @Output() ipstatus = new EventEmitter<IPStatusDto[]>()
  @Output() deleteIPStatusEvent = new EventEmitter<any>()

    selectedIPStatus: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     ) {}

    ngOnChanges() {
      this.createIPStatusForm();
    }

    createIPStatusForm() {
      this.ipstatusForm = this.fb.group({
        IPStatusName: ['', Validators.required],
     
        id: null
        });
        this.ipstatusFormArray = this.fb.group({ IPStatuss: this.fb.array([])
          });
        this.setIPStatus();
    }

  // method to display ipstatuss
  setIPStatus() {
    const control  = this.ipstatusFormArray.controls.IPStatuss as FormArray;
    this.ipstatuss.forEach( e => {
      control.push(
        this.fb.group({
          IPStatusName: e.IPStatusName,
        
          id: e.id
        })
      );
    });
  }


  // method to add IPStatus
  addIPStatus(value: IPStatusDto) {
    const control  = this.ipstatusFormArray.controls.IPStatuss as FormArray;
    control.insert(0,
          this.fb.group({
            IPStatusName: value.IPStatusName,
          
            id: null
          })
       );
  }

  selectIPStatus(value) {}

  // method to delete ipstatus from arrary list
  deleteIPStatus(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.ipstatusFormArray.controls.IPStatuss as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.ipstatuss.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.ipstatuss[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: IPStatusDto) {
    if(this.ipstatusForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.ipstatusFormArray.get('IPStatuss')['controls'][this.selectedIndex].patchValue({IPStatusName: formValue.IPStatusName});
    } else {
      this.addIPStatus(formValue);
    }
    this.selectedIndex = null;
    this.ipstatusForm.reset()
  }

  onEdit(index, value: IPStatusDto) {
    console.log(index, value)
    this.selectedIndex = index;
    this.ipstatusForm.patchValue({IPStatusName: value.IPStatusName});
   
  }

  onClearForm() {
    this.selectedIndex = null;
    this.ipstatusForm.reset();
  }

  onSubmit(formValue: IPStatusDto[]) {
  this.ipstatus.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteIPStatusEvent.emit(this.filteredDelete);
  }
  }

}
